module.exports = __webpack_public_path__ + "roboto-italic-webfont.2895006ec2a236d76c79.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-italic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-italic-webfont.woff2
// module chunks = styles